var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50.7692 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1311 0.686729C19.5279 0.682522 21.8607 1.92476 23.1452 4.14947L33.226 21.6098C35.1378 24.9211 34.0033 29.1554 30.692 31.0671C27.3808 32.9789 23.1465 31.8441 21.2347 28.5329L17.113 21.3938L12.9913 28.5329C11.0796 31.8441 6.84554 32.9788 3.5343 31.0671C0.223042 29.1554 -0.911411 24.9211 1.00034 21.6098L11.0809 4.14947C12.3653 1.92477 14.6982 0.682576 17.095 0.686729H17.1311Z",
    fill: "#4858A8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.231,
    cy: 24.1537,
    r: 7.53846,
    fill: "#4858A8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.231,
    cy: 7.53846,
    r: 6.53846,
    stroke: "#4858A8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.85fdfb9f4a76161ee0ee59b204ee28a0.svg";
export { ForwardRef as ReactComponent };